import { render, staticRenderFns } from "./Producao.vue?vue&type=template&id=4850f449"
import script from "./Producao.vue?vue&type=script&lang=js"
export * from "./Producao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports